import { ReportMapEntity } from './report-map-entity.service';
import { CameraService } from './camera.service';
import { CoreService } from './core.service';
import { GenericAttribute } from './generic-attribute.service';
import { TextEntityAttribute } from './text-entity-attribute.service';
import { SingleAttachmentEntityAttribute } from './single-attachment-entity-attribute.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataContextService } from './data-context.service';
import { DefaultEditCommand } from '../models/command';
import { TimelineService } from './timeline.service';

export class UpdateMapEntity extends ReportMapEntity {
  data: any;
  lastUpdate: string;
  localTime: string;
  arcAngelId: string;
  eventId: string;
  isPublic: boolean;
  geometry: any;
  isOfficial: boolean;
  validAt: string;
  isRejected?: boolean;
  rejectedBy?: string;
  isApproved?: boolean;
  approvedBy?: string;
  override attachments: any[] = [];

  constructor(
    update: any,
    eventId: string,
    playback: boolean,
    cameraService: CameraService,
    coreService: CoreService,
    windowService: WindowService,
    dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService
  ) {
    super(
      playback ? `arc-angel-playback-${update.id}` : `arc-angel-${update.id}`,
      update.description,
      'ArcAngel//Updates',
      'assets/img/arcangel/marker-update-unapproved.png',
      update.geometry.coordinates[1],
      update.geometry.coordinates[0],
      update.altitude,
      new Date(Date.parse(update.updatedAt)),
      '',
      cameraService,
      coreService,
      windowService,
      dataContext,
      modalService,
      timelineService
    );
    this.data = update;
    this.lastUpdate = update.updatedAt;
    const date = new Date(Date.parse(update.updatedAt));
    this.localTime = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    this.arcAngelId = update.id;
    this.eventId = eventId;
    this.isPublic = update.isPublic;
    this.geometry = update.geometry;
    this.isOfficial = update.officialUpdate;
    this.validAt = update.validAt;
    this.description = update.description;
    this.attachments[0] = update.attachment;
    this.addAttribute(new GenericAttribute('Approve/Reject', this.getId(), false, false, 0, 'eventupdateattributevisualizer'));
    this.addAttribute(new TextEntityAttribute('Description', this.getId(), 'description'));

    const attachment = update.attachment;
      if (
        (Array.isArray(attachment) && attachment.length > 0) ||
        (typeof attachment === 'string' && attachment)
      ) {
        const attachmentAttribute = new SingleAttachmentEntityAttribute('Attachment', this.getId());
        attachmentAttribute.url = Array.isArray(attachment) ? attachment[0] : attachment;
        this.addAttribute(attachmentAttribute);
      }

    for (let i = this.commands.length - 1; i >= 0; i--) {
      if (this.commands[i] instanceof DefaultEditCommand) {
        this.removeCommand(this.commands[i]);
      }
    }
    if (update.rejectedBy) {
      this.setRejected(update.rejectedBy);
    } else if (update.approvedBy) {
      this.setApproved(update.approvedBy);
    }
  }

  getEventId(): string {
    return this.eventId;
  }

  override setDescription(text: string) {
    this.description = text;
    this.name = this.truncateString(text, 25);
  }

  getDescription(): string {
    return this.description ?? '';
  }

  getGeometry(): any {
    return this.geometry;
  }

  setAttachment(attachment: any): void {
    if (this.attachments[0] !== attachment) {
      if (this.attachments[0] === undefined) {
        this.attachments[0] = attachment;
        const attachmentAttribute = new SingleAttachmentEntityAttribute('Attachment', this.getId());
        this.addAttribute(attachmentAttribute);
      } else {
        this.attachments[0] = attachment;
      }
    }
  }

  update(data: any) {
    this.data = data;
    this.setLastUpdate(data.updatedAt);
    this.setDescription(data.description);
    this.setAttachment(data.attachment);
    this.isPublic = data.isPublic;

    if (data.rejectedBy) {
      this.setRejected(data.rejectedBy);
    } else if (data.approvedBy) {
      this.setApproved(data.approvedBy);
    }
    // this.setPushpinIcon(this.getIconFromStatus(), true);
  }

  getData(): any {
    return this.data;
  }

  setLastUpdate(lastUpdate: string) {
    this.lastUpdate = lastUpdate;
  }

  getLastUpdate(): string {
    return this.lastUpdate;
  }

  getArcAngelId(): string {
    return this.arcAngelId;
  }

  getIsPublic(): boolean {
    return this.isPublic;
  }

  getIsPrivate(): boolean {
    return !this.isPublic;
  }

  getIconFromStatus(): string {
    if (this.isRejected) {
      return 'img/arcangel/marker-update-rejected.png';
    } else if (this.isOfficial) {
      return 'img/arcangel/marker-update-official.png';
    } else if (this.isApproved) {
      return 'img/arcangel/marker-update-approved.png';
    }
    return 'img/arcangel/marker-update-unapproved.png';
  }

  setRejected(byWho: string) {
    this.isRejected = true;
    this.rejectedBy = byWho;
    // this.setPushpinIcon(this.getIconFromStatus(), true);
    this.hide();
  }

  setApproved(byWho: string) {
    this.isRejected = false;
    this.rejectedBy = undefined;
    this.isApproved = true;
    this.approvedBy = byWho;
    // this.setPushpinIcon(this.getIconFromStatus(), true);
    this.show();
  }

  getIsRejected(): boolean {
    return !!this.isRejected;
  }

  getIsApproved(): boolean {
    return !!this.isApproved && !this.isRejected;
  }

  getIsPending(): boolean {
    return !this.isApproved && !this.isRejected;
  }

  override getShowIn2d(): boolean {
    return false;
  }

  override getShowIn3d(): boolean {
    return !this.isRejected;
  }

  getStatus(): string {
    return this.data.status;
  }

  // Utility
  private truncateString(str: string, num: number): string {
    if (!str) return '';
    return str.length <= num ? str : str.slice(0, num) + '...';
  }
}